export default __webpack_public_path__ + "static/media/akouo-mini-logo-white.de73ef67.svg";